import TaxStatementsScreen from 'features/statementsAndForms/screens/TaxStatements/TaxStatementsScreen';
import React from 'react';

export default function TaxStatementsPage() {
  return <TaxStatementsScreen />;
}
